import React, { useState } from "react";

function FaqComponent() {
  const [openIndex, setOpenIndex] = useState(-1);

  const toggleItem = (index) => {
    if (openIndex === index) {
      setOpenIndex(-1);
    } else {
      setOpenIndex(index);
    }
  };

  const faqData = [
    {
      question: "Is EasyACC a billing software?",
      answer:
        "Yes, EasyACC is a billing software that allows businesses to create GST invoices, manage their inventory and generate multiple reports.",
    },
    {
      question:
        "Which is the best software for billing?",
      answer:
        "EasyACC is also a billing software that is widely used by small and medium businesses in India. Multiple formats for Invoice printing are available. It simplifies financial operations by offering advanced features such as invoicing, inventory management, e-way bill generation, GST reports and analysis, purchase management, bank management, and cash management capabilities.",
    },
    {
      question: "What is EasyACC Software?",
      answer:
        "EasyACC is a comprehensive accounting, inventory and invoicing management software; specially designed for small and medium businesses, traders, retailers, dealers, distributors, and manufacturing units.",
    },
    {
      question:
        "What are the features of EasyACC?",
      answer:
        "EasyACC offers advanced features such as Accounting, invoicing, inventory management with e-way bill generation, GST reports & analysis, Sales & Purchase management, Bank & cash management. All these capabilities make EasyACC a complete financial management software solution.",
    },
    {
      question: "How can EasyACC help my business?",
      answer:
        "EasyACC can simplify financial operations, save time and effort, optimize financial performance and help businesses stay compliant with regulations such as GST. It provides users with a range of useful features that can help them manage their finances efficiently.",
    },
  ];

  return (
    <>
      <div id="FAQ" className="sm:flex py-20 sm:px-8 bg-[#ffffff] relative items-center">
        <div className="w-full px-5 flex justify-center">
          <div className="sm:flex items-center bg-[#e6f7ff] border-2 rounded-2xl shadow-xl px-2 sm:px-12 pb-10 w-full max-w-7xl">
            <div className="flex flex-col items-center sm:w-[30%]">
              <h2 className="font-bold text-5xl mt-5 tracking-tight">
                FA
                <span
                  style={{
                    backgroundImage:
                      "linear-gradient(120deg, #0077b3 0%, #00aacc 100%)",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                    color: "transparent",
                  }}
                >
                  Q
                </span>
              </h2>
              <p className="text-neutral-500 text-xl mt-2">
                Frequently asked questions
              </p>
            </div>
            <div className="sm:w-[70%] grid sm:px-0 divide-y divide-neutral-200 mx-auto mt-8">
              {faqData.map((faq, index) => (
                <div className="py-5" key={index}>
                  <details
                    className={`group ${openIndex === index ? "open" : ""}`}
                    open={openIndex === index}
                  >
                    <summary
                      className="flex justify-between  text-xl items-center font-medium cursor-pointer list-none"
                      onClick={() => toggleItem(index)}
                    >
                      <span className="px-4 text-2xl">{faq.question}</span>
                      <span className="transition bg-[#0077b3] mx-4 rounded-full group-open:rotate-180">
                        <svg
                          fill="none"
                          height="24"
                          shapeRendering="geometricPrecision"
                          stroke="white"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.5"
                          viewBox="0 0 24 24"
                          width="24"
                        >
                          <path d="M6 9l6 6 6-6"></path>
                        </svg>
                      </span>
                    </summary>
                    <p
                      className={`text-gray-900 text-xl mt-3 px-4 ${
                        openIndex === index ? "fadeIn" : ""
                      }`}
                    >
                      {faq.answer}
                    </p>
                  </details>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* <div className="sm:w-1/2 mt-10 sm:mt-0 px-5">
          <div className="text-center pb-6">
            <p className="mb-2 text-4xl text-black font-extrabold">
              A Word from our <span className="text-[#7decc6]">Customers</span>
            </p>
            <p className="mb-0 text-lg">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Necessitatibus, iusto?
            </p>
          </div>
          <Review />
        </div> */}
      </div>
    </>
  );
}

export default FaqComponent;
